import { render } from "./VehicleCard.vue?vue&type=template&id=54992b48&scoped=true"
import script from "./VehicleCard.vue?vue&type=script&lang=js"
export * from "./VehicleCard.vue?vue&type=script&lang=js"

import "./VehicleCard.vue?vue&type=style&index=0&id=54992b48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54992b48"]])

export default __exports__